import { render, staticRenderFns } from "./UsuariosAdmin.vue?vue&type=template&id=4ddb563e&scoped=true&"
import script from "./UsuariosAdmin.vue?vue&type=script&lang=js&"
export * from "./UsuariosAdmin.vue?vue&type=script&lang=js&"
import style0 from "./UsuariosAdmin.vue?vue&type=style&index=0&id=4ddb563e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ddb563e",
  null
  
)

export default component.exports